import axios, { type AxiosInstance } from 'axios'
import { type ClientRegistry, type ClientNames } from '../types'

export type AxiosClients = Partial<Record<ClientNames, readonly AxiosInstance[]>>

class AxiosClientRegistry implements ClientRegistry<AxiosInstance> {
  clients: AxiosClients

  constructor() {
    this.clients = {}
  }

  setClients(clients: AxiosClients) {
    this.clients = clients
  }

  getClient(clientName: keyof AxiosClients, mock?: boolean) {
    const client = mock ? this.clients[clientName]?.[1] : this.clients[clientName]?.[0]
    if (!client) {
      console.error(`[AxiosClientRegistry] Client ${clientName} not found.`)
      return axios.create()
    }
    return client
  }
}

export const axiosClientRegistry = new AxiosClientRegistry()
